import React from 'react';
import { Alert, ReactAux } from '@jkhy/vsg-design-system';
/* eslint-disable import/no-extraneous-dependencies, no-unused-vars */
import * as H from 'history';
import AntivirusResponse_ from '../../data/models/AntivirusResponse';
import { HealthCheckModel } from '../../redux/actions/health-check-actions';

export interface CustomRouteComponentProps<P> {
  match: match<P>;
  location: H.Location;
  history: H.History;
  staticContext?: any;
}

export interface match<P> {
  params: P;
  isExact: boolean;
  path: string;
  url: string;
}

export interface urlParams {
  autologout: string;
}

export type BaseType = {
  loading?: boolean,
  antiVirusScanResult?: AntivirusResponse_,
  healthCheck?: HealthCheckModel,
} & CustomRouteComponentProps<urlParams>

interface IContent {
  content: () => JSX.Element
}

export class Base<TProps extends BaseType, TState> extends React.Component<TProps, TState> implements IContent {
  componentDidCatch = error => {
    return <Alert type="danger" text={error.toString()} />;
  };

  content = () => <></>;

  render = () => {
    return (
      <ReactAux>
        { this.content()}
      </ReactAux>
    );
  }
}
